import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'flight-rules-legend-svg',
  templateUrl: './flight_rules_legend.svg',
  styleUrl: '../../../../../twc-legend/shared-legend-svg.css',
  standalone: true,
  imports: [CommonModule]
})
export class FlightRulesSvgComponent {}
